import { Component } from '@angular/core';

@Component({
    selector: 'chat',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class ChatComponent {}
